import { Contact, LogOut, ShieldCheck, Users } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

export function buildProGroup(ctx: StaffNavContext): StaffNavGroup | null {
  const children: StaffNavNode[] = []

  if (ctx.showProOnboarding) {
    children.push(
      leaf(
        'pro_visa_cases',
        'Visa Cases',
        AppPaths.proOnboardingHub,
        ShieldCheck,
        ['pro', 'visa', 'visa cases', 'onboarding', 'pro — visa cases'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showProExit) {
    children.push(
      leaf(
        'pro_exit_cases',
        'Employee Exit',
        AppPaths.proExitHub,
        LogOut,
        ['pro', 'exit', 'visa cancellation', 'offboarding', 'pro — employee exit'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showProWorkforceDirectory) {
    children.push(
      leaf(
        'pro_employee_directory',
        'Employee Directory',
        AppPaths.workforceDirectory,
        Contact,
        ['employee', 'directory', 'roster', 'visa', 'passport'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showProDeskAdmin) {
    children.push(
      leaf(
        'pro_desk_admin',
        'Desk admin',
        AppPaths.proDeskAdmin,
        Users,
        ['assistant', 'shareef', 'sub user', 'who did', 'admin'],
      ),
    )
  }

  return group('pro', 'PRO', ShieldCheck, ['pro', 'visa', 'exit'], children)
}
